import { render, staticRenderFns } from "./IconApprovals.vue?vue&type=template&id=aab70930&scoped=true"
import script from "./IconApprovals.vue?vue&type=script&lang=ts"
export * from "./IconApprovals.vue?vue&type=script&lang=ts"
import style0 from "./IconApprovals.vue?vue&type=style&index=0&id=aab70930&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab70930",
  null
  
)

export default component.exports